import { useCallback, useRef, useState } from 'react';

// Manages typing indicator with throttling and debouncing
export const useTypingIndicator = ({ isConnected, sendMessage, conversationId }) => {
  const [isTyping, setIsTyping] = useState(false);
  const typingTimeoutRef = useRef(null);
  const lastTypingEmitRef = useRef(0);
  const typingQueueRef = useRef([]);

  const setTyping = useCallback((isUserTyping) => {
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    setIsTyping(isUserTyping);

    if (isUserTyping) {
      const now = Date.now();
      if (now - lastTypingEmitRef.current > 500) {
        lastTypingEmitRef.current = now;
        typingQueueRef.current.push({ isTyping: true, conversationId });
        if (isConnected) {
          sendMessage('typing', { isTyping: true, conversationId });
        }
      }

      typingTimeoutRef.current = setTimeout(() => {
        setIsTyping(false);
        typingQueueRef.current.push({ isTyping: false, conversationId });
        if (isConnected) {
          sendMessage('typing', { isTyping: false, conversationId });
        }
        typingQueueRef.current = [];
      }, 1000);
    }
  }, [isConnected, sendMessage, conversationId]);

  return { isTyping, setTyping };
};

export default useTypingIndicator;


